// SEO Metadata aus CSV
export const seoData = {
  "/schluesseldienst-dortmund/": {
    title: "Schlüsseldienst Dortmund – 119 € (Mo–Fr 8–20) | Sa–So 199 €",
    description: "Schnelle Türöffnung in ganz Dortmund. Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inklusive. Jetzt anrufen: 0231 39085116."
  },
  "/preise/": {
    title: "Preise – Schlüsseldienst Dortmund: 119 € (Mo–Fr 8–20), Sa–So 199 €",
    description: "Transparente Festpreise für Türöffnungen in Dortmund. Anfahrt inklusive, faire Zuschläge nur bei Mehraufwand. Beispiele & Zahlungsarten."
  },
  "/einsatzgebiete/": {
    title: "Einsatzgebiete – Schlüsseldienst Dortmund & alle Stadtteile",
    description: "Hilfe in allen Dortmunder PLZ und Stadtteilen – schnelle Anfahrt, Festpreise und schonende Türöffnung."
  },
  "/schluesseldienst-dortmund-aplerbeck/": {
    title: "Schlüsseldienst Aplerbeck, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Aplerbeck (44287). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-berghofen/": {
    title: "Schlüsseldienst Berghofen, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Berghofen (44287, 44265). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-schueren/": {
    title: "Schlüsseldienst Schüren, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Schüren (44265). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-soelde/": {
    title: "Schlüsseldienst Sölde, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Sölde (44319). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-loh/": {
    title: "Schlüsseldienst Loh, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Loh (44287). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-eving/": {
    title: "Schlüsseldienst Eving, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Eving (44339, 44369, 44388, 44534). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-brechten/": {
    title: "Schlüsseldienst Brechten, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Brechten (44329). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-holthausen/": {
    title: "Schlüsseldienst Holthausen, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Holthausen (44329). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-kemminghausen/": {
    title: "Schlüsseldienst Kemminghausen, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Kemminghausen (44339). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-lindenhorst/": {
    title: "Schlüsseldienst Lindenhorst, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Lindenhorst (44339). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-hombruch/": {
    title: "Schlüsseldienst Hombruch, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Hombruch (44225, 44227). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-kirchhoerde/": {
    title: "Schlüsseldienst Kirchhörde, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Kirchhörde (44225). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-luecklemberg/": {
    title: "Schlüsseldienst Lücklemberg, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Lücklemberg (44225). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-barop/": {
    title: "Schlüsseldienst Barop, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Barop (44225). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-menglinghausen/": {
    title: "Schlüsseldienst Menglinghausen, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Menglinghausen (44227). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-hoerde/": {
    title: "Schlüsseldienst Hörde, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Hörde (44263, 44265). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-benninghofen/": {
    title: "Schlüsseldienst Benninghofen, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Benninghofen (44267). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-syburg/": {
    title: "Schlüsseldienst Syburg, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Syburg (44265, 58456). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-wellinghofen/": {
    title: "Schlüsseldienst Wellinghofen, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Wellinghofen (44265, 44267). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-huckarde/": {
    title: "Schlüsseldienst Huckarde, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Huckarde (44369). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-rahm/": {
    title: "Schlüsseldienst Rahm, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Rahm (44369). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-wischlingen/": {
    title: "Schlüsseldienst Wischlingen, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Wischlingen (44369). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-kirchlinde/": {
    title: "Schlüsseldienst Kirchlinde, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Kirchlinde (44379). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-hafen/": {
    title: "Schlüsseldienst Hafen, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Hafen (44147). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-nordmarkt/": {
    title: "Schlüsseldienst Nordmarkt, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Nordmarkt (44145, 44147). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-scharnhorst/": {
    title: "Schlüsseldienst Scharnhorst, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Scharnhorst (44145). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-mitte-ost/": {
    title: "Schlüsseldienst Mitte-Ost, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Mitte-Ost (44135, 44137, 44141, 44143). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-koerne/": {
    title: "Schlüsseldienst Körne, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Körne (44143). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-westfalenhuette/": {
    title: "Schlüsseldienst Westfalenhütte, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Westfalenhütte (44141). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-mitte-west/": {
    title: "Schlüsseldienst Mitte-West, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Mitte-West (44135, 44137, 44139). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-dorstfeld/": {
    title: "Schlüsseldienst Dorstfeld, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Dorstfeld (44149). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-kreuzviertel/": {
    title: "Schlüsseldienst Kreuzviertel, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Kreuzviertel (44139). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-luetgendortmund/": {
    title: "Schlüsseldienst Lütgendortmund, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Lütgendortmund (44388). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-boevinghausen/": {
    title: "Schlüsseldienst Bövinghausen, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Bövinghausen (44388). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-marten/": {
    title: "Schlüsseldienst Marten, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Marten (44379). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-oespel/": {
    title: "Schlüsseldienst Oespel, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Oespel (44149). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-mengede/": {
    title: "Schlüsseldienst Mengede, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Mengede (44357). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-bodelschwingh/": {
    title: "Schlüsseldienst Bodelschwingh, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Bodelschwingh (44357). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-groppenbruch/": {
    title: "Schlüsseldienst Groppenbruch, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Groppenbruch (44536). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-nette/": {
    title: "Schlüsseldienst Nette, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Nette (44359). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-oestrich/": {
    title: "Schlüsseldienst Oestrich, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Oestrich (44357). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-scharnhorst-scharnhorst/": {
    title: "Schlüsseldienst Scharnhorst, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Scharnhorst (44328, 44329). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-alt-scharnhorst/": {
    title: "Schlüsseldienst Alt-Scharnhorst, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Alt-Scharnhorst (44328). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-derne/": {
    title: "Schlüsseldienst Derne, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Derne (44329). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-grevel/": {
    title: "Schlüsseldienst Grevel, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Grevel (44329, 44339). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-lanstrop/": {
    title: "Schlüsseldienst Lanstrop, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Lanstrop (44328). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-brackel/": {
    title: "Schlüsseldienst Brackel, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Brackel (44309). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-asseln/": {
    title: "Schlüsseldienst Asseln, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Asseln (44319). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-wambel/": {
    title: "Schlüsseldienst Wambel, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Wambel (44143). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  },
  "/schluesseldienst-dortmund-wickede/": {
    title: "Schlüsseldienst Wickede, Dortmund – 119 € (8–20)",
    description: "Schnelle Türöffnung in Wickede (44319). Mo–Fr 08–20: 119 €, Sa–So: 199 €. Anfahrt inkl. Jetzt anrufen: 0231 39085116."
  }
};
